export default __webpack_public_path__ + "static/media/logo.d5c92e84.png";